<template>
  <NotificationText v-bind="$props">
    <template #primary>
      <i>{{notification.data.userDeletedName}}</i> hat den Raum
      <i>{{notification.data.roomName}}</i> gelöscht
    </template>
  </NotificationText>
</template>

<script>
  import NotificationTextMixin from '../notification-text-mixin';


  export default {
    name: 'RoomDeleted',

    mixins: [
      NotificationTextMixin
    ]
  };
</script>
